import { useContext, useState } from "react";
import { AccountLifecycleQuartzClientContext } from "../../../shared/services/api/contexts";
import { Loading } from "../../../shared/components/feedback/loading/Loading";
import AlertDialogModal from "../../../shared/components/ui/AlertDialogModal";
import { useSnackbar } from "../../../shared/components/layout/SnackbarContext";

export const UserProfileAccountLifecycle: React.FC<{}> = () => {
  const accountLifecycleQuartzClient = useContext(AccountLifecycleQuartzClientContext);

  const [loading, setLoading] = useState(false);
  const [openDeleteData, setOpenDeleteData] = useState(false);
  const [openDeleteAccount, setOpenDeleteAccount] = useState(false);
  const { showSnackbar } = useSnackbar();
  const handleDeleteData = async () => {
    setLoading(true);
    try {
      await accountLifecycleQuartzClient.initiateDataDeletionCountdown();
      setOpenDeleteData(false);
      setLoading(false);
    } catch (e: any) {
      console.error("Data deletion request failed:", e);
      showSnackbar({ text: "Data deletion request failed.", color: "danger" });
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    await accountLifecycleQuartzClient.initiateAccountDeletionCountdown();
  };

  if (loading) {
    return <Loading message={"Deleting data ..."} />;
  }
  return (
    <>
      <AlertDialogModal
        alertMessage="Are you sure you want to delete all the data? All data will be deleted within 7 days."
        open={openDeleteData}
        setOpen={setOpenDeleteData}
        handleDelete={handleDeleteData}
      />
      <AlertDialogModal
        alertMessage="Are you sure you want to delete this account? You will be logout and lost access to your account. All data will be deleted within 7 days."
        open={openDeleteAccount}
        setOpen={setOpenDeleteAccount}
        handleDelete={handleDeleteAccount}
      />
      <h2>Delete data</h2>
      <hr />
      <p>Remove all data including documents, notes, cohorts, and results from your account.</p>
      <p>
        <strong>All data will be deleted within 7 days.</strong>
      </p>
      <button
        className="button is-danger"
        onClick={() => {
          setOpenDeleteData(true);
        }}
      >
        Delete data
      </button>
      <h2>Delete account</h2>
      <hr />
      <p>Delete your account and all linked data.</p>
      <p>
        <strong>
          You will be logout and lost access to your account. All data will be deleted within 7
          days.
        </strong>
      </p>
      <button
        className="button is-danger"
        onClick={() => {
          setOpenDeleteAccount(true);
        }}
      >
        Delete your account
      </button>
    </>
  );
};
